var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4c639"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.45.234l1.44 2.57C9.215 4.14 7.365 6.7 7.365 9.692h17.27c0-2.98-1.85-5.55-4.523-6.888l1.44-2.57s.103-.103-.103-.206c-.103-.103-.206.103-.206.103L19.7 2.702a9.35 9.35 0 0 0-3.804-.822 9.35 9.35 0 0 0-3.804.822l-1.54-2.57S10.45.03 10.346.03a.36.36 0 0 0 .103.206zM11.9 5.27c.4 0 .822.4.822.822s-.4.822-.822.822a.81.81 0 0 1-.822-.822.81.81 0 0 1 .822-.822zm8.224 0c.4 0 .822.4.822.822s-.4.822-.822.822a.81.81 0 0 1-.822-.822.81.81 0 0 1 .822-.822zM7.262 10.72v13.16c0 .617.822 1.542 1.44 1.542h2.056v4.523c0 1.13.822 2.056 1.85 2.056s1.85-.925 1.85-2.056V25.42h2.98v4.523c0 1.13.822 2.056 1.85 2.056s1.85-.925 1.85-2.056V25.42h2.056c.617 0 1.44-.822 1.44-1.542V10.72z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 23.234
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M4.383 10.412c1.028 0 1.85.925 1.85 2.056v7.813c0 1.13-.822 2.056-1.85 2.056s-1.85-.925-1.85-2.056v-7.813c0-1.13.822-2.056 1.85-2.056z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidLogo);
export default __webpack_public_path__ + "static/media/AndroidLogo.aece715709de8d8b809af6dbcf62651d.svg";
export { ForwardRef as ReactComponent };